export default __webpack_public_path__ + "static/media/Benchmarks_purple.c77093f4.svg";